/**
 * Formata para exibição (dd/MM/yyyy) uma data vinda do backend.
 *
 * O backend devolve datas em dois formatos, conforme o endpoint:
 * - "dd/MM/yyyy" (DTOs formatados, ex.: GET /vagas) -> devolvida como está.
 *   Passá-la por `new Date()` a interpretava como mês/dia americano
 *   ("17/09/2026" virava "Invalid Date" e "11/09/2026" virava 09/11/2026).
 * - "yyyy-MM-dd" ou ISO com hora (entidades, ex.: GET /vagas/empresa/{id}) ->
 *   tratada como data LOCAL. `new Date("2026-09-28")` é meia-noite UTC e, no
 *   fuso de Brasília, aparecia como 27/09/2026.
 *
 * Valor vazio ou inválido devolve `fallback`.
 */
export const formatarData = (
  data?: string | null,
  fallback: string = "-",
): string => {
  if (!data) return fallback;
  const texto = String(data).trim();

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(texto)) {
    return texto;
  }

  const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(texto);
  if (iso) {
    const [, ano, mes, dia] = iso;
    const local = new Date(Number(ano), Number(mes) - 1, Number(dia));
    if (
      local.getFullYear() === Number(ano) &&
      local.getMonth() === Number(mes) - 1 &&
      local.getDate() === Number(dia)
    ) {
      return `${dia}/${mes}/${ano}`;
    }
    return fallback;
  }

  return fallback;
};
